import styled from "styled-components";
export const OnlineChatSupplierStyle = styled.div`
  .chat-box {
    background-color: ${({ theme }) => theme.box};
    margin-top: 1rem;

    border-radius: 0.625rem;
    overflow: hidden;
    .chat-holder {
      overflow-x: hidden;
      padding: 10px;
      height: 600px;
      overflow-y: scroll;
      scrollbar-width: thin;
      scrollbar-color: #eff2f5 transparent;
    }
  }
`;
